import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Linkedin, ArrowRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#00316B] text-white pt-20 pb-10" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-23">
          <div className="col-span-1 md:col-span-1" data-id="element-24">
            <Link to="/" className="mb-6 block" data-id="element-25">
              <img src="https://cdn.magicpatterns.com/uploads/qZq5o2kR7qajKU24kpFCJC/blogo.svg" alt="Belo Digital" className="h-8 w-auto brightness-0 invert" data-id="element-26" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-27">
              Designing digital experiences that drive real business growth. We
              build modern, scalable solutions for forward-thinking brands.
            </p>
          </div>

          <div data-id="element-28">
            <h4 className="font-heading font-semibold mb-6 text-lg" data-id="element-29">
              Services
            </h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-30">
              <li data-id="element-31">
                <Link to="/services" className="text-blue-200 hover:text-white transition-colors" data-id="element-32">
                  Digital Product Design
                </Link>
              </li>
              <li data-id="element-33">
                <Link to="/services" className="text-blue-200 hover:text-white transition-colors" data-id="element-34">
                  Web & App Development
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/services" className="text-blue-200 hover:text-white transition-colors" data-id="element-36">
                  Brand Identity
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/services" className="text-blue-200 hover:text-white transition-colors" data-id="element-38">
                  Growth Strategy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-39">
            <h4 className="font-heading font-semibold mb-6 text-lg" data-id="element-40">Company</h4>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-41">
              <li data-id="element-42">
                <Link to="/about" className="text-blue-200 hover:text-white transition-colors" data-id="element-43">
                  About Us
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/work" className="text-blue-200 hover:text-white transition-colors" data-id="element-45">
                  Selected Work
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/careers" className="text-blue-200 hover:text-white transition-colors" data-id="element-47">
                  Careers
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/contact" className="text-blue-200 hover:text-white transition-colors" data-id="element-49">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-50">
            <h4 className="font-heading font-semibold mb-6 text-lg" data-id="element-51">
              Let's Talk
            </h4>
            <p className="text-gray-400 text-sm mb-6" data-id="element-52">
              Have a project in mind? We'd love to hear about it.
            </p>
            <Link to="/contact" className="inline-flex items-center text-white font-medium hover:text-gray-300 transition-colors group" data-id="element-53">
              Start a Project{' '}
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-54" />
            </Link>

            <div className="flex space-x-4 mt-8" data-id="element-55">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-56">
                <Twitter size={20} data-id="element-57" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-58">
                <Instagram size={20} data-id="element-59" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-60">
                <Linkedin size={20} data-id="element-61" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-blue-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-blue-300" data-id="element-62">
          <p data-id="element-63">
            &copy; {new Date().getFullYear()} Belo Digital. All rights reserved.
          </p>
          <div className="flex items-center gap-6 mt-2 md:mt-0" data-id="element-64">
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-65">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-66">
              Privacy Policy
            </Link>
            <p data-id="element-67">Designed with intention.</p>
          </div>
        </div>
      </div>
    </footer>;
}